// extracted by mini-css-extract-plugin
export default {"rewardsRow":"admin_rewardsRow__Hyrfd"};